export default {
    path: "bill-management",
    name: "Billing Management",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            component: () => import("@/views/bill-management/index.vue"),
          },
          {
            path: "history/:id",
            name: "History",
            component: () => import("@/views/bill-management/history.vue"),
          },
        ]
      },
      {
        path:"/trialBilling/:id",
        name:"Trial Billing",
        component: () => import("@/views/bill-management/trialBilling.vue"),
      },
      {
        path:"/billing/:id",
        name:"Billing",
        component: () => import("@/views/bill-management/billing.vue"),
      },
      {
        path: "/listViewReports/:report_name",
        name: "List View Reports",
        component: () => import("@/views/reports/listViewReports.vue"),
      },
    ],
  };
  